import { LayersTypes } from 'components/MapLayers/MapLayers.model';
import { RiChargingPileFill } from 'react-icons/ri';
import { IMapLayers } from './MapLayersOptions.model';
import { t } from 'i18next';


export const useLayersItems = (chosenOption?: LayersTypes[]): IMapLayers[] => {
  const result = [
    {
      name: 'EV',
      title: t('components.mapLayers.options.ev'),
      icon: RiChargingPileFill,
      type: LayersTypes.EV,
    },
    {
      name: 'bookings',
      title: t('components.mapLayers.options.bookings'),
      icon: 'dots',
      type: LayersTypes.Booking,
    },
    {
      name: 'HeatMap',
      title: t('components.mapLayers.options.heatMap'),
      icon: 'heatMap',
      type: LayersTypes.Heat,
    },
  ];

  if (chosenOption) {
    return result.filter((item: IMapLayers) => chosenOption.includes(item.type));
  }

  return result;
};
